import { z } from 'zod';

export const CoreNotifyCommunicationAttemptScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','direction','communicationType','channelType','status','reasonCode','reasonText','smsSegments','voiceDurationInSeconds','twilioStatus','twilioSid','massNotificationId','anonymousContactId','subscriberContactMethodId','billingTransactionId']);

export default CoreNotifyCommunicationAttemptScalarFieldEnumSchema;
